import React from "react";
import styled, { css } from "styled-components";
import usePluginEntities from "hooks/usePluginEntities";
import StandardFooter from "./StandardFooter";
const StyledFooter = styled.footer(
  ({ theme }) => css`
    text-align: center;
    font-size: ${theme.fonts.size.small};
    color: ${theme.colors.gray[70]};
    height: 20px;

    /* This combination of padding and box-sizing is required to fix a firefox flexbox bug */
    box-sizing: content-box;
    padding-bottom: ${theme.spacings.sm};

    @media print {
      display: none;
    }
  `
);
const Footer = () => {
  const customFooter = usePluginEntities("pageFooter");
  if (customFooter.length === 1) {
    const CustomFooter = customFooter[0].component;
    return /* @__PURE__ */ React.createElement(StyledFooter, null, /* @__PURE__ */ React.createElement(CustomFooter, null));
  }
  return /* @__PURE__ */ React.createElement(StyledFooter, null, /* @__PURE__ */ React.createElement(StandardFooter, null));
};
export default Footer;
